export const accordion = {
  accordion: {
    colorScheme: {
      light: {
        header: {
          // Default state
          background: '{surface.0}',
          color: 'var(--p-text-color)',
          borderColor: '{slate.200}',

          // Hover state (when accordion is closed)
          hoverBackground: '{primary.50}',
          hoverColor: '{primary.700}',

          // Active/Selected state (when accordion is open)
          activeBackground: '{primary.50}',
          activeColor: '{primary.700}',

          // Active + Hover state (when accordion is open and hovered)
          activeHoverBackground: '{primary.100}',
          activeHoverColor: '{primary.800}',

          // Border radius
          firstTopBorderRadius: '0',
          lastBottomBorderRadius: '0',
        },
        panel: {
          borderColor: '{slate.200}',
        },
        content: {
          padding: '1.125rem',
          background: '{surface.0}',
        },
      },
    },
  },
};
